import {DrupalNode} from "next-drupal";
import {HTMLProps} from "react";
import {Button} from "../../atoms/button";
import classNames from "classnames";
// import {ImageIcon} from "../../atoms/icon";
import {absoluteURL} from "../../../lib/absolute-url";
import {FormattedText} from "../../formatted-text";

export function BenefitCard({node}: {node: DrupalNode}) {
  const defaultBenefit = node.field_benefit_default_benefit;
  const title = node?.field_benefit_title_override ?? defaultBenefit?.field_benefit_display_title;
  const smallDescription = node?.field_benefit_desc_sm_override ?? defaultBenefit?.field_benefit_small_description;
  const largeDescription = node?.field_benefit_desc_lg_override ?? defaultBenefit?.field_benefit_description_large;
  const documentLinkText = node?.field_benefit_document_link_text;
  const document = node?.field_benefit_document;
  // const icon = node?.field_benefit_default_benefit?.field_benefit_icon?.name ?? "";
  // const iconPosition = node?.field_benefit_icon_pos_override
  //   ?? node?.field_benefit_default_benefit?.field_benefit_icon_position
  //   ?? "left";

  return (
    <div key={node.id} className="bg-white py-8 md:py-12 text-center drop-shadow-sm rounded-md">
      {/* @todo hide icons before launch, revisit. */}
      {/*{(icon && iconPosition === "top") && (*/}
      {/*  <div className="mb-2 h-12">*/}
      {/*    <ImageIcon type={icon} color="primary" height={50} width={50} alt={title} className="m-auto object-contain max-h-full"/>*/}
      {/*  </div>*/}
      {/*)}*/}
      <div className="font-bold text-primary text-2xl pb-3 px-8 md:px-12">
        <div className="flex items-center justify-center">
          {/* @todo hide icons before launch, revisit. */}
          {/*{(icon && iconPosition === "left") && (*/}
          {/*  <ImageIcon type={icon} color="primary" height={2} width={25} alt={title} className="mr-3"/>*/}
          {/*)}*/}
          <FormattedText processed={title}/>
        </div>
      </div>
      <div className="px-8 md:px-12">
        {largeDescription && (
          <div className="font-light text-2xl pb-3">
            <FormattedText processed={largeDescription}/>
          </div>
        )}
        {smallDescription && (
          <div className="font-light pb-3">
            <FormattedText processed={smallDescription}/>
          </div>
        )}
        {(documentLinkText && document) && (
          <Button href={absoluteURL(document?.field_media_file?.uri?.url)} target={"_blank"} className="text-sm mt-3" invert={true} hover={{color: "primary"}}>{documentLinkText}</Button>
        )}
      </div>
    </div>
  )
}

interface BenefitSectionProps extends HTMLProps<HTMLDivElement> {
  benefits?: DrupalNode[],
}

/**
 * Renders benefit nodes into a grid.
 *
 * The following fields should be included on the node to render correctly.:
 * - field_benefits_benefits
 * - field_benefits_benefits.field_benefit_default_benefit
 *
 * @param node
 * @constructor
 */
export function BenefitSection({benefits, ...props}: BenefitSectionProps) {

  if (!benefits?.length) {
    return <></>
  }

  return (
    <div className={classNames("container mx-auto", props?.className ?? "")}>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 md:pt-8">
        {benefits.map(item => <BenefitCard node={item} key={item.id}/>)}
      </div>
    </div>
  )
}
